// Infinite scroll row slider
function createInfiniteScroll(container, direction = 'vertical') {
    const slides = container.children;

    if (slides.length === 0) return;

    if (direction === 'horizontal') {
        const slideElements = container.querySelectorAll('.slide-element');
        let totalWidth = 0;

        slideElements.forEach((slide) => {
            const slideWidth = slide.offsetWidth;
            const slideStyle = window.getComputedStyle(slide);
            const marginLeft = parseFloat(slideStyle.marginLeft) || 0;
            const marginRight = parseFloat(slideStyle.marginRight) || 0;
            totalWidth += slideWidth + marginLeft + marginRight;
        });

        const gaps = slideElements.length - 1;
        totalWidth += gaps * 80;

        container.style.width = `${totalWidth}px`;
    }

    const clonesToAdd = Math.min(3, slides.length);
    for (let i = 0; i < clonesToAdd; i++) {
        const clone = slides[i].cloneNode(true);
        clone.classList.add('cloned-slide');
        container.appendChild(clone);
    }

    let currentTranslate = 0;
    const isVertical = direction === 'vertical';

    const slideDimension = isVertical
        ? slides[0].offsetHeight + 80
        : slides[0].offsetWidth + 80;

    const totalSlides = slides.length - clonesToAdd;
    const speed = 1;
    let animationId;
    let isPaused = false;

    function animateScroll() {
        if (!isPaused) {
            currentTranslate -= speed;

            if (Math.abs(currentTranslate) >= slideDimension * totalSlides) {
                currentTranslate = 0;
            }

            const transform = isVertical
                ? `translateY(${currentTranslate}px)`
                : `translateX(${currentTranslate}px)`;

            container.style.transform = transform;
        }
        animationId = requestAnimationFrame(animateScroll);
    }

    animateScroll();

    container.addEventListener('mouseenter', () => {
        isPaused = true;
    });

    container.addEventListener('mouseleave', () => {
        isPaused = false;
    });
}

const rowSlider = document.querySelectorAll('.row-slider');

rowSlider.forEach((rowSlider) => {
    const typeSlider = rowSlider.getAttribute('data-typeslider');

    if (typeSlider === 'vertical') {
        createInfiniteScroll(rowSlider, 'vertical');
    }

    if (typeSlider === 'horizontal') {
        createInfiniteScroll(rowSlider, 'horizontal');
    }
});
// End infinite scroll row slider
